/*
 * @Author: Musa Tabitay
 * @Date: 2020-04-05 23:24:28
 * @LastEditTime: 2022-05-02 15:33:05
 */

// 查看菜单列表
const menus = [
  {
    name: 'باسقارۋ',
    path: 'course',
    icon: 'el-icon-s-finance',
    children: [
      {
        name: 'ۋيچات تەكشە',
        path: '/wechatconfig',
        icon: 'el-icon-s-tools'
      },
      {
        name: 'باننەر جارناما',
        path: '/swiper',
        icon: 'el-icon-s-finance'
      },
      {
        name: 'مۇعالىم',
        path: '/teacherList',
        icon: 'el-icon-s-opportunity'
      },
      // {
      //   name: 'ايدارشا',
      //   path: '/topic',
      //   icon: 'el-icon-s-shop'
      // },
      {
        name: 'ساباق ءتۇرى',
        path: '/category',
        icon: 'el-icon-s-grid'
      },
      {
        name: 'ساباق',
        path: '/course',
        icon: 'el-icon-edit-outline'
      }
      // {
      //   name: 'قيمىل',
      //   path: '/activity',
      //   icon: 'el-icon-s-shop'
      // }
    ]
  },
  {
    name: 'ەسەپ',
    path: 'member',
    icon: 'el-icon-s-finance',
    children: [
      {
        name: 'VIP ءتۇرى',
        path: '/member',
        icon: 'el-icon-s-goods'
      },
      {
        name: 'VIP مۇشە',
        path: '/vip',
        icon: 'el-icon-user'
      },
      {
        name: 'جەكە ساتىلىم',
        path: '/order',
        icon: 'el-icon-price-tag'
      },
      {
        name: 'مۇشەلەر',
        path: '/users',
        icon: 'el-icon-s-custom'
      },
      {
        name: 'قولداۋ',
        path: '/appreciates',
        icon: 'el-icon-user'
      }
      // {
      //   name: 'قيمىل ساتىلىمى',
      //   path: '/activityList',
      //   icon: 'el-icon-s-shop'
      // }
    ]
  }
]

export { menus }



// WEBPACK FOOTER //
// ./src/views/menus.js